import React from 'react';
import { Link } from 'react-router-dom'; // Added Link for internal linking if needed later, safe to keep

const categories = [
  {
    id: 1,
    // Title updated for Delhi SEO
    title: 'Royal Living in Delhi', 
    // Subtitle updated for Service Keyword
    subtitle: 'LIVING ROOM DESIGN', 
    // Description packed with location & material keywords
    description: 'Transform your space into a modern palace. We specialize in luxury living room interiors in South Delhi and Noida, featuring Italian marble and bespoke furniture.',
    image: 'https://chiedesign.in/wp-content/uploads/2022/05/Luxury-Interior-Design-Living-Room.jpg',
    align: 'left',
  },
  {
    id: 2,
    // Title updated for Lucknow SEO
    title: 'Bedroom Renovation Lucknow',
    subtitle: 'MASTER BEDROOM',
    description: 'Experience the Nawabi comfort. Our bedroom designs in Lucknow blend heritage aesthetics with modern lighting and space-saving wardrobes.',
    image: 'https://i.pinimg.com/originals/9f/ab/34/9fab341b9c775b18b1dec05fb2da39fb.jpg',
    align: 'right',
  },
  {
    id: 3,
    // Title updated for Varanasi SEO
    title: 'Modular Kitchens Varanasi',
    subtitle: 'CULINARY ELEGANCE',
    description: 'High-gloss finishes and German hardware. We build rust-proof, termite-resistant modular kitchens perfectly suited for homes in Varanasi and UP East.',
    image: 'https://www.emporiumkitchens.com.au/wp-content/uploads/2024/10/Modern-Luxury-Kitchen-Design.png',
    align: 'left',
  },
  {
    id: 4,
    // Title updated for Noida/Turnkey SEO
    title: 'Turnkey Interiors Noida',
    subtitle: 'FULL HOME INTERIORS',
    description: 'From civil work to final styling. Our turnkey home renovation services in Noida ensure you get a ready-to-move-in luxury home without the hassle.',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&q=80&w=1000',
    align: 'right', 
  },
];

const CategorySection = () => {
  return (
    <div className="bg-white py-16 px-4 md:px-8 font-sans">
      
      {/* Header */}
      <div className="text-center mb-12">
        <span className="text-amber-600 tracking-[0.2em] text-xs font-bold uppercase mb-2 block">
          Our Specializations
        </span>
        <h2 className="text-3xl md:text-4xl text-neutral-900 font-serif mb-4">
          Curated Interiors for <br />
          <span className="italic text-gray-500">Modern Indian Homes</span>
        </h2>
        <div className="w-12 h-[2px] bg-neutral-900 mx-auto"></div>
      </div>

      {/* Tighter Layout - max-w-6xl aur gap kam (SAME STRUCTURE) */}
      <div className="max-w-6xl mx-auto flex flex-col">
        {categories.map((item, index) => (
          <div 
            key={item.id} 
            className={`flex flex-col md:flex-row items-center ${
              item.align === 'right' ? 'md:flex-row-reverse' : ''
            }`}
          >
            {/* Image Side - Width 50% aur Image Height adjust */}
            <div className="w-full md:w-1/2 relative group overflow-hidden">
              <img 
                src={item.image} 
                alt={item.title} // SEO: Title now contains keywords, so Alt text is automatically optimized
                className="w-full h-[350px] md:h-[450px] object-cover transition-transform duration-700 ease-in-out group-hover:scale-105"
              />
              {/* Optional: Overlay effect for better blending */}
              <div className="absolute inset-0 bg-black/5 group-hover:bg-transparent transition-all duration-500"></div>
            </div>

            {/* Content Side - Width 50% with Padding to center text */}
            <div className="w-full md:w-1/2 py-8 md:py-0 px-6 md:px-16 text-center md:text-left bg-white relative z-10">
              <h4 className="text-amber-600 font-bold text-4xl tracking-widest uppercase mb-2">
                {item.subtitle}
              </h4>
              <h3 className="text-3xl font-serif text-neutral-900 mb-4 leading-tight">
                {item.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-6">
                {item.description}
              </p>
              
              {/* Button commented out as per original file */}
              {/* <button className="text-xs font-bold uppercase tracking-widest border-b-2 border-neutral-900 pb-1 hover:text-amber-600 hover:border-amber-600 transition-all duration-300">
                View Project
              </button> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategorySection;